<div [class]="classPrefix('MainPod')">
  <section [class]="classPrefix('Pod0')">
    <wml-form-zero [props]="mainForm"></wml-form-zero>
    <wml-accordion-zero [props]="friendAccordion"></wml-accordion-zero>
  </section>
</div>
